define("calendar/utils/time-slots", ["exports", "later/utils/time-format"], function (_exports, _timeFormat) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.computeTimeSlotDiffInMins = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/utils/time-format"eaimeta@70e063a35619d71f

  const computeTimeSlotDiffInMins = (timeSlotOne, timeSlotTwo) => {
    const week = _timeFormat.convert.days(7).toMinutes();

    const diffInMins = timeSlotOne.get('mow') - timeSlotTwo.get('mow');

    if (diffInMins < 0) {
      return -diffInMins;
    }

    if (week / 2 < diffInMins) {
      return week - diffInMins;
    }

    return diffInMins;
  };

  _exports.computeTimeSlotDiffInMins = computeTimeSlotDiffInMins;
});